import React from 'react'

const EducationPositionIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
		<rect width="50" height="50" fill="#e6e7f3" rx="25" />
		<path
			fill="#030A7E"
			fillRule="evenodd"
			d="M37.362 29.818a2.463 2.463 0 011.64 2.319c0 .978-.574 1.824-1.402 2.22l1.36 4.08-1.556.518-.862-2.586-.862 2.586-1.555-.519 1.36-4.079a2.462 2.462 0 01-1.402-2.22c0-1.069.685-1.98 1.64-2.319v-7.827l-3.335 1.333v3.894c0 1.203-.843 2.287-2.374 3.052-1.35.675-3.128 1.047-5.004 1.047-1.877 0-3.654-.372-5.005-1.047-1.53-.765-2.374-1.85-2.374-3.052v-3.901L11 20.659l14.01-5.614 14.045 5.614-1.693.677v8.482zm-12.352-.14c3.284 0 5.738-1.3 5.738-2.46v-3.239l-5.739 2.294-5.738-2.3v3.245c0 1.16 2.454 2.46 5.739 2.46zm0-5.17l-9.602-3.849 9.602-3.848 9.627 3.848-9.627 3.848zm10.712 7.629a.82.82 0 001.64 0 .82.82 0 00-1.64 0z"
			clipRule="evenodd"
		/>
	</svg>
)

export default EducationPositionIcon
